mobileSize = 1000;

function placeCountdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    if ($('body').hasClass('homepage')) {
      $('.countdown-outer-wrapper').prependTo('.content');
    }
    if ($('body').hasClass('fair-homepage')) {
      $('.countdown-outer-wrapper').prependTo('.afterContent');
    }
  } else {
    $('.countdown-outer-wrapper').appendTo('.headerInnerContent');
  }
}

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 975) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 976) {
    $('body').removeClass('saffireMobileSize');
  }

  // Remove afterContent container from all pages except for the Fair homepage
  if ($('body').hasClass('fair-homepage')) {
    $('.afterContent').show();
  } else {
    $('.afterContent').remove();
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Place Countdown
  placeCountdown();

  // Custom Email Signup
  if ($('body').hasClass('homepage') || $('body').hasClass('fair-homepage')) {
    $('.emailSignup .emailSignupText').text('Sign up for news & updates from Walworth County Fairgrounds.');
    $('.emailSignup .emailSubmitButton')
      .appendTo('.emailInputField')
      .text('Subscribe');
  }

  // Set Header Logo Link
  if ($('body').hasClass('fair')) {
    $('.header-logo').attr('href', '/p/the-fair')
  } else {
    $('.header-logo').attr('href', '/');
  }

  // Set Footer Logo Link
  if ($('body').hasClass('fair')) {
    $('.footer-logo').attr('href', '/');
  } else {
    $('.footer-logo').attr('href', '/p/the-fair');
  }

  // Fairgrounds Link
  if ($('body').hasClass('fair')) {
    $('.fairgrounds-link').show();
  } else {
    $('.fairgrounds-link').hide();
  }

  // Target attribute for ticket button
  $(".ticket").attr("target", "_blank");
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});

$(window).resize(function(){
  // Place Countdown
  placeCountdown();
});